import { DocumentIcon, Sidebar } from 'ComponentLibrary'
import { compact } from 'lodash'
import { useTranslation } from 'react-i18next'

export const SIDEBAR_WIDTH = '178px'

function OrderManagementSidebar() {
    const { t } = useTranslation('pages', { keyPrefix: 'orders.orderManagementSidebar' })
    const { t: tTerminology } = useTranslation('terminology', { keyPrefix: 'common' })
    const menuItems = [
        {
            icon: DocumentIcon,
            label: t('orderList'),
            slug: 'overview',
        },
    ]

    return (
        <Sidebar
            style={{ marginBottom: 'unset', minWidth: SIDEBAR_WIDTH, maxWidth: SIDEBAR_WIDTH }}
            elements={{
                [tTerminology('orders')]: compact(menuItems),
            }}
        />
    )
}

export { OrderManagementSidebar }
